// ui classes are required, but not explicitly loaded via AMD
define('tinymce-ui',[
        "tinymce/EditorManager", "tinymce/ui/AbsoluteLayout", "tinymce/ui/FieldSet", "tinymce/ui/Layout", "tinymce/ui/ResizeHandle", "tinymce/ui/ButtonGroup", "tinymce/ui/FilePicker", "tinymce/ui/ListBox", "tinymce/ui/Scrollable", "tinymce/ui/Button", "tinymce/ui/FitLayout", "tinymce/ui/MenuBar", "tinymce/ui/Selector", "tinymce/ui/Checkbox", "tinymce/ui/FlexLayout", "tinymce/ui/MenuButton", "tinymce/ui/Spacer", "tinymce/ui/Collection", "tinymce/ui/FloatPanel", "tinymce/ui/MenuItem", "tinymce/ui/SplitButton", "tinymce/ui/ColorButton", "tinymce/ui/FlowLayout", "tinymce/ui/Menu", "tinymce/ui/StackLayout", "tinymce/ui/ComboBox", "tinymce/ui/FormatControls", "tinymce/ui/MessageBox", "tinymce/ui/TabPanel", "tinymce/ui/Container", "tinymce/ui/FormItem", "tinymce/ui/Movable", "tinymce/ui/TextBox", "tinymce/ui/Control", "tinymce/ui/Form", "tinymce/ui/PanelButton", "tinymce/ui/Throbber", "tinymce/ui/DomUtils", "tinymce/ui/GridLayout", "tinymce/ui/Panel", "tinymce/ui/Toolbar", "tinymce/ui/DragHelper", "tinymce/ui/Iframe", "tinymce/ui/Path", "tinymce/ui/Tooltip", "tinymce/ui/ElementPath", "tinymce/ui/KeyboardNavigation", "tinymce/ui/Radio", "tinymce/ui/Widget", "tinymce/ui/Factory", "tinymce/ui/Label", "tinymce/ui/Resizable", "tinymce/ui/Window"
], function(EditorManager, AbsoluteLayout, FieldSet, Layout, ResizeHandle, ButtonGroup, FilePicker, ListBox, Scrollable, Button, FitLayout, MenuBar, Selector, Checkbox, FlexLayout, MenuButton, Spacer, Collection, FloatPanel, MenuItem, SplitButton, ColorButton, FlowLayout, Menu, StackLayout, ComboBox, FormatControls, MessageBox, TabPanel, Container, FormItem, Movable, TextBox, Control, Form, PanelButton, Throbber, DomUtils, GridLayout, Panel, Toolbar, DragHelper, Iframe, Path, Tooltip, ElementPath, KeyboardNavigation, Radio, Widget, Factory, Label, Resizable, Window) {
	EditorManager.ui = {
		AbsoluteLayout: AbsoluteLayout,
		FieldSet: FieldSet,
		Layout: Layout,
		ResizeHandle: ResizeHandle,
		ButtonGroup: ButtonGroup,
		FilePicker: FilePicker,
		ListBox: ListBox,
		Scrollable: Scrollable,
		Button: Button,
		FitLayout: FitLayout,
		MenuBar: MenuBar,
		Selector: Selector,
		Checkbox: Checkbox,
		FlexLayout: FlexLayout,
		MenuButton: MenuButton,
		Spacer: Spacer,
		Collection: Collection,
		FloatPanel: FloatPanel,
		MenuItem: MenuItem,
		SplitButton: SplitButton,
		ColorButton: ColorButton,
		FlowLayout: FlowLayout,
		Menu: Menu,
		StackLayout: StackLayout,
		ComboBox: ComboBox,
		FormatControls: FormatControls,
		MessageBox: MessageBox,
		TabPanel: TabPanel,
		Container: Container,
		FormItem: FormItem,
		Movable: Movable,
		TextBox: TextBox,
		Control: Control,
		Form: Form,
		PanelButton: PanelButton,
		Throbber: Throbber,
		DomUtils: DomUtils,
		GridLayout: GridLayout,
		Panel: Panel,
		Toolbar: Toolbar,
		DragHelper: DragHelper,
		Iframe: Iframe,
		Path: Path,
		Tooltip: Tooltip,
		ElementPath: ElementPath,
		KeyboardNavigation: KeyboardNavigation,
		Radio: Radio,
		Widget: Widget,
		Factory: Factory,
		Label: Label,
		Resizable: Resizable,
		Window: Window
	};
	return EditorManager;
});

